'use client';

import Image from 'next/image';

interface AlbumRenderThumbnailStripProps {
  /** URLs of the renders that will be packed into the album — one per angle
   *  whose selected/latest completed render feeds the PDF. */
  urls: string[];
}

/**
 * Horizontal strip of the renders that will be included in the album — one
 * small thumbnail per angle whose render feeds the PDF. Shown at the top of the
 * album settings so the user can confirm the image set at a glance. Mirrors the
 * Apple/Android album-settings render strip. Renders nothing when empty.
 */
export function AlbumRenderThumbnailStrip({
  urls,
}: AlbumRenderThumbnailStripProps) {
  if (urls.length === 0) return null;

  return (
    <div className="flex gap-2 overflow-x-auto py-1">
      {urls.map((url, index) => (
        <div
          key={`${url}-${index}`}
          className="relative aspect-[4/3] h-[72px] flex-shrink-0 overflow-hidden rounded-lg bg-muted"
        >
          <Image src={url} alt="" fill sizes="96px" className="object-cover" />
        </div>
      ))}
    </div>
  );
}
